/** A Radix select cannot hold an empty value, so "not set" has a name of its own. */
export const NO_TYPE = '__none__';

/**
 * BY LABEL: a ticket stores its request type as the label ("Access request
 * (grant/add/share)"), which is what intake writes and every screen and
 * report reads. Writing the key here would give it a type nothing expects.
 *
 * The desk's request types, plus "Not set", plus the ticket's own type when
 * it is not one of them (a type since removed, or one from an import) --
 * otherwise the select would show nothing and look as though it had no type.
 */
export function requestTypeOptions(
  types: readonly { key: string; label: string; sortOrder: number }[],
  current: string | null,
): { value: string; label: string }[] {
  const listed = [...types].sort((a, b) => a.sortOrder - b.sortOrder).map((x) => ({ value: x.label, label: x.label }));
  const extra = current && !listed.some((o) => o.value === current) ? [{ value: current, label: current }] : [];
  return [{ value: NO_TYPE, label: 'Not set' }, ...extra, ...listed];
}
